import React from 'react';
import { useTranslation } from 'react-i18next';
import './order-form-footer.component.scss';

interface OrderFormFooterProps {
    onCancel: () => void;
    onSubmit: () => void;
    isEditMode?: boolean;
    isEmployerCertificateDraft?: boolean;
    onUpdate?: () => void;
    onSaveDraft?: () => void;
    onUpdateDraft?: () => void;
    disabled?: boolean;
    isSavingDraft?: boolean;
    isUpdatingDraft?: boolean;
}

export const OrderFormFooter: React.FC<OrderFormFooterProps> = ({
    onCancel,
    onSubmit,
    isEditMode = false,
    isEmployerCertificateDraft = false,
    onUpdate,
    onSaveDraft,
    onUpdateDraft,
    disabled = false,
    isSavingDraft = false,
    isUpdatingDraft = false,
}) => {
    const { t } = useTranslation();

    const ShieldIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
            <path d="m9 12 2 2 4-4" />
        </svg>
    );

    return (
        <div className="order-form-footer">
            <button 
                type="button"
                className="order-form-footer__cancel"
                onClick={onCancel}
            >
                {t('Cancel')}
            </button>
            
            {isEmployerCertificateDraft ? (
                onUpdateDraft && (
                    <button 
                        type="button"
                        className="order-form-footer__draft"
                        onClick={onUpdateDraft}
                        disabled={isUpdatingDraft}
                    >
                        {isUpdatingDraft ? t('Saving...') : t('Update Draft')}
                    </button>
                )
            ) : (
                onSaveDraft && !isEditMode && (
                    <button 
                        type="button"
                        className="order-form-footer__draft"
                        onClick={onSaveDraft}
                        disabled={isSavingDraft}
                    >
                        {isSavingDraft ? t('Saving...') : t('Save Draft')}
                    </button>
                )
            )}
            
            {isEditMode && !isEmployerCertificateDraft ? (
                <button 
                    type="button"
                    className="order-form-footer__submit"
                    onClick={onUpdate}
                    disabled={disabled}
                >
                    <ShieldIcon />
                    {t('Update')}
                </button>
            ) : (
                <button 
                    type="button"
                    className="order-form-footer__submit"
                    onClick={onSubmit}
                    disabled={disabled}
                >
                    <ShieldIcon />
                    {t('Submitemployercertifcate')}
                </button>
            )}
        </div>
    );
};
